<template>
  <v-app class="font">
    <!-- app bar -->
    <app-bar></app-bar>

    <!-- side menu -->
    <navigation-drawer></navigation-drawer>

    <!-- main -->
    <v-main>
      <router-view class="px-16 pt-16"></router-view>
    </v-main>

    <!-- snackbar -->
    <!-- <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      top
      end
      timeout="3000"
    >
      {{ snackbarMessage }}
    </v-snackbar> -->
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavigationDrawer from "./components/organisms/NavigationDrawer.vue";
import AppBar from "./components/organisms/AppBar.vue";
import { auth0Module } from "@/store/dataModules/auth0Module";
import LocalDataService from "@/service/LocalDataService";
import { meModule } from "@/store/dataModules/meModule";
import { MeResponse } from "chaild-api/lib";
import JwtDecode, { JwtPayload } from "jwt-decode";

/** created 内の認証初期化が一度だけ走るようにする */
let appAuthInitDone = false;

export default defineComponent({
  name: "App",

  components: {
    NavigationDrawer,
    AppBar,
  },
  /*
  data: () => ({
    routePath: '',
    loading: false,
    me: null as MeResponse | null,
  }),
  created: async function() {
    console.log('app created');
    this.loading = true;
    this.routePath = this.$route.path;
    try {
      // 認証チェック
      await auth0Module.initClient();
      const isAuthenticated = await auth0Module.isAuthenticated();
      if (isAuthenticated) {
        this.me = await meModule.fetchMe();
        this.isToFirstStep();
      } else {
        try {
          auth0Module.getTokenSilently();
          // console.log('OK getTokenSilently:', response);
          this.me = await meModule.fetchMe();
          this.isToFirstStep();
        } catch (error) {
          // console.log('error catch getTokenSilently:', error);
          if (this.$route.query && this.$route.query.code && this.$route.query.state) {
            await auth0Module.handleAuth0();
          }
          console.log('再度サインインプロセスへ');
          await auth0Module.signinProcess();
        }
      }
    } catch (error) {
            console.log('エラーのためサインインプロセスへ', error);
            await auth0Module.signinProcess();
    } finally {
      this.loading = false;
    }
  },
  */  

  data() {
    return {
      //fromAuth0: false,
    };
  },

  created: async function() {
    if (appAuthInitDone) return;
    appAuthInitDone = true;

    await auth0Module.initClient();

    // コールバック検出: Vue Router の query がまだ入っていない場合があるため window.location も参照
    const search = typeof window !== "undefined" ? window.location.search : "";
    const hasCodeInUrl = !!(this.$route.query?.code && this.$route.query?.state) ||
      (search.includes("code=") && search.includes("state="));

    if (hasCodeInUrl) {
      try {
        await auth0Module.handleAuth0();
        // 成功したら URL から code/state を除去（ブラウザバックで同じ code を再送しないため）
        await this.$router.replace({ path: "/signin", query: {} }).catch(() => {});
      } catch (e) {
        console.warn("handleAuth0 failed:", e);
        // コールバック処理に失敗しても signIn() は呼ばない（ループ防止）
        return;
      }
    }

    if (this.tokenExists) {
      const response = await meModule.fetchMe();
      if (
        response &&
        response.nurserySchools &&
        response.nurserySchools.length > 0
      ) {
        const me: MeResponse | null = meModule.me;
        if (me) {
          const currentSchool = me.nurserySchools.find((s) => {
            return s.isDefault == true;
          });
          if (currentSchool) {
            LocalDataService.setNurseryId(currentSchool.nurseryId);
            meModule.setNurseryId(currentSchool.nurseryId);
          } else if (me.nurserySchools.length > 0) {
            LocalDataService.setNurseryId(me.nurserySchools[0].nurseryId);
            meModule.setNurseryId(me.nurserySchools[0].nurseryId);
          }
        }
        if (auth0Module.accessToken) {
          const decoded: JwtPayload = JwtDecode(auth0Module.accessToken);
          if (decoded?.exp && decoded.exp <= Math.round(Date.now() / 1000)) {
            auth0Module.logout();
          }
        }
        if (this.$route.path === "/signin" || this.$route.path === "/signup" || this.$route.path === "/") {
          this.goTop();
        }
      } else {
        const res = await meModule.postWithNoBody();
        if (res) {
          this.goTop();
        }
      }
    } else {
      // code なしのときだけログイン画面へリダイレクト（コールバック後に token が無い場合は既に return 済み）
      if (!hasCodeInUrl) {
        auth0Module.signIn();
      }
    }
  },

  computed: {
    tokenExists(): boolean {
      const token = auth0Module.accessToken;
      return token ? true : false;
    },
    /*
    snackbar: {
      get() {
        return snackbarModule?.isShow;
      },
      set() {
        snackbarModule.setIsShow(false);
      },
    },
    snackbarMessage: {
      get() {
        return snackbarModule?.message;
      },
    },
    snackbarColor: {
      get() {
        return snackbarModule?.color;
      },
    },
    */
  },

  methods: {
    goTop() {
      this.$router.push({ path: "/attendance/list" });
    },
    signUp() {
      this.$router.push({ path: "/signup" });
    },
    /*
    async isToFirstStep() {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (user.nurserySchools.length === 0) {
          this.$router.push('/signup');
        }
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const currentUserId = `${nurserySchool.userId}`;
        const token = await auth0Module.getAuth0Token();
        if (currentUserId && token) {
          console.log('set auth');
         // LocalDataService.setPushAuthorizer(`${token},${currentUserId}`);
        }
      }
      if (this.me && this.me.nurserySchools.length > 0) {
        //pusherModule.subscribe();
        this.loading = false;
        console.log(`this.routePath: ${this.routePath}`)
        if (this.routePath == '/signin' || this.routePath == '/signup' || this.routePath == '/') {
          this.$router.push('/signin');
          // 引数を1つだけ渡す（移動先のパス）
          this.$router.push('/signin').catch(err => {
            // ナビゲーション中に発生したエラーをここでキャッチ(重複したナビゲーションエラー)
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      } else {
        this.loading = false;
        this.$router.push('/signup');
      }
    },
    */
  },
});
</script>
<style>
/* @import url(https://fonts.googleapis.com/earlyaccess/notosansjp.css); */

/* Number Inputの矢印を隠す */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.font {
  font-family: "Noto Sans JP", sans-serif, system-ui !important;
}

div.swal2-container {
  z-index: 3000 !important;
}

.search-button {
  min-width: 110px;
}
</style>
